<template>
  <div class=" px-4 justify-center  w-full">
    <div class="justify-center flex mb-4  min-w-[300px] max-w-[300px]">
      <span class="text-sm" v-html="value.message"></span>
    </div>
    <div class="w-full flex gap-2 mb-2">
      <button class="bg-trader-gray hover:bg-trader-blue hover:text-white w-1/2 rounded p-2 mt-2" @click="deleteTrue"
              data-ui="delete-yes">Ja
      </button>
      <button class="bg-trader-gray hover:bg-trader-blue hover:text-white w-1/2 rounded p-2 mt-2" @click="deleteFalse"
              data-ui="delete-no">Nein
      </button>
    </div>
  </div>
</template>
<script>

import {eventBus} from "@/application/EventBus.js";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    deleteTrue() {

      try {
        if(this.value.onAccept){
          this.value.onAccept();
          eventBus.closeModal();
        }
      } catch (e) {}
    },
    deleteFalse() {
      eventBus.closeModal();
      try {
        if (this.value.onCancel) {
          this.value.onCancel();
          //eventBus.closeModal();
        }
      } catch (e) {
      }
    }
  },
}
</script>

